import React from 'react';
import onClickOutside from 'react-onclickoutside';
import _ from 'lodash';
import { faLockAlt } from '@fortawesome/pro-solid-svg-icons';
import {
	faUserFriends,
	faUser,
	faSignOutAlt,
} from '@fortawesome/free-solid-svg-icons';
import DropdownContent from '../DropdownContent/DropdownContent';

import SiteToolsTestIds from '../SiteTools.elements';
import ResponsiveLayout from '../../../Common/ResponsiveLayout/ResponsiveLayout';
import Portal from '../../../Common/Portal/Portal';
import topMenuTestIds from '../../TopMenu.elements';
import {
	toggleMenuOnTab,
	toggleMenuOnShiftTab,
	setMenuToggleHandler,
} from '../../../../../logic/functions/common/menuDisplayToggle';
import * as Styled from './styled';

interface SiteToolsDropdownProps {
	parentRef: React.RefObject<HTMLAnchorElement>;
	adviserGroups: string[];

	onClickOutside(event: any): void;
}

export class SiteToolsDropdown extends React.Component<SiteToolsDropdownProps> {
	constructor(props: any) {
		super(props);
		setMenuToggleHandler(this.props.onClickOutside);
	}

	handleClickOutside = (event: any) => {
		this.props.onClickOutside(event);
	};

	displayProfileDetails = () =>
		_.find(this.props.adviserGroups, role =>
			_.includes('wmmkofficeuser', role.toLowerCase())
		);

	render() {
		const changePasswordURL = `/changePassword?returnurl=${window.location.origin}/online/home`;

		return (
			<Portal
				node={document.getElementById(
					SiteToolsTestIds.siteToolsUserDetailsDropdownContainer
				)}
			>
				<ResponsiveLayout
					parentRef={this.props.parentRef.current}
					dataId={topMenuTestIds.SiteToolsDropdown}
				>
					<Styled.DropdownList
						id="dropdownListId"
						data-id={SiteToolsTestIds.dropdownList}
						onKeyUp={(event: any) => toggleMenuOnTab(event, true)}
						onKeyDown={(event: any) => toggleMenuOnShiftTab(event, true)}
					>
						<DropdownContent
							testId={SiteToolsTestIds.dropdownChangePassword}
							firstItem={true}
							imageIcon={faLockAlt}
							contentLink={changePasswordURL}
							contentText="Change Password"
						/>
						{this.displayProfileDetails() ? (
							<DropdownContent
								testId={SiteToolsTestIds.dropdownProfileDetails}
								imageIcon={faUser}
								contentLink="/user/office/updateDetails"
								contentText="Profile Details"
								openInNewTab
							/>
						) : (
							<DropdownContent
								testId={SiteToolsTestIds.dropdownManageOfficeUsers}
								imageIcon={faUserFriends}
								contentLink="/user/office/maintenance/access"
								contentText="Manage office users"
							/>
						)}
						<DropdownContent
							testId={SiteToolsTestIds.dropdownLogout}
							imageIcon={faSignOutAlt}
							contentLink="/logout?logoutReason=user&userType=Advisor"
							contentText="Logout"
						/>
					</Styled.DropdownList>
				</ResponsiveLayout>
			</Portal>
		);
	}
}

export default onClickOutside(SiteToolsDropdown);
